export namespace GasButton {
  export type ButtonInputType = ButtonType | 'primary' | 'secondary' | 'negative' | '';

  export enum ButtonType  {
    Primary = 'primary',
    Secondary = 'secondary',
    Negative = 'negative',
  }
}
